import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientSideRowModelModule, ModuleRegistry } from 'ag-grid-community';
import { AllEnterpriseModule } from 'ag-grid-enterprise';
import { BaseAppComponent, PagesModule } from '@r1-development/rps-shared-ui';
import { Title } from '@angular/platform-browser';
import { AuthService } from '@auth0/auth0-angular';
import { MissingRefreshTokenError } from '@auth0/auth0-spa-js';

// Register AG Grid modules
ModuleRegistry.registerModules([ClientSideRowModelModule, AllEnterpriseModule]);
@Component({
  selector: 'app-root',
  imports: [PagesModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent extends BaseAppComponent implements OnInit {
  constructor(
    protected override readonly activatedRoute: ActivatedRoute,
    protected override readonly router: Router,
    protected override readonly titleService: Title,
    private readonly auth: AuthService
  ) {
    super(activatedRoute, router, titleService);
  }

  ngOnInit(): void {
    this.auth.error$.subscribe((error) => {
      if (error instanceof MissingRefreshTokenError) {
        this.auth.logout();
      }
    });
  }
}
